import { render, staticRenderFns } from "./salesInitiaReturnList.vue?vue&type=template&id=74dab470&scoped=true"
import script from "./salesInitiaReturnList.vue?vue&type=script&lang=js"
export * from "./salesInitiaReturnList.vue?vue&type=script&lang=js"
import style0 from "./salesInitiaReturnList.vue?vue&type=style&index=0&id=74dab470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dab470",
  null
  
)

export default component.exports